<template>
    <div class="dropdown-container">
        <div class="dropdown-action">
            <template v-if="type === 'button'">
                <button @click="toggleDropdown" class="button">
                    <slot name="actionContent" v-bind:dropDownShown="dropDownShown">{{label}}</slot>
                </button>
            </template>
            <template v-else>
                <a @click.prevent="toggleDropdown" href="#">
                    <slot name="actionContent" v-bind:dropDownShown="dropDownShown">{{label}}</slot>
                </a>
            </template>
        </div>
        <transition name="toggle">
            <div class="dropdown-content" v-if="dropDownShown && !disabled" ref="dropDownContent" :style="coordinates">
                <slot/>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        props:{
            type: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: 'Dropdown label'
            },
            disabled: {
                type: Boolean
            },
            align:{
                type: String,
                default: 'left'
            },
            offsetTop:{
                type: Number,
                default: 0
            },
            width: {
                type: String,
                default: 'auto'
            },
        },
        data(){
            return {
                dropDownShown: false,
                coordinates: {},
            }
        },

        methods: {
            toggleDropdown(){
                this.dropDownShown = !this.dropDownShown;
                this.$nextTick(() => {
                    if(this.dropDownShown){
                        let top = this.offsetTop === 'auto' ? this.$el.offsetHeight : this.$el.offsetHeight + this.offsetTop;
                        let left = 0;

                        if(this.align === 'right'){
                            left = this.$el.offsetWidth - this.$refs.dropDownContent.offsetWidth;
                        }

                        this.coordinates = {
                            top: top + 'px',
                            left: left + 'px'
                        }
                    }
                });
            },
            outSideClose(e) {
                if(!this.$el.contains(e.target)){
                    this.dropDownShown = false
                }
            },
        },
        mounted () {
            this.$nextTick(() => {
                window.addEventListener('click', this.outSideClose)
            })
        },
        beforeDestroy () {
            window.removeEventListener('click', this.outSideClose)
        }
    }
</script>

<style lang="scss" scoped>
    .dropdown-container {
        position: relative;

        .dropdown-action{
            span {
                margin-right: 8px;
                font-size: 1.2rem;
            }
            a {
                color: $primary-color;
                text-decoration: none;
            }
        }
        .dropdown-content{
            position: absolute;
            z-index: 9999;
            width: auto;
            min-width: 150px;
            padding: 20px;
            border-radius: $border-middle-radius;
            box-shadow: $box-shadow;
            background-color: $white;
            text-align: left;
        }
    }

    .toggle-enter, .toggle-leave-active{
        opacity: 0;
        transform: translateY(-10px);
    }
    .toggle-enter-active, .toggle-leave-active{
        transition: all ease .2s;
    }
</style>